import httpRequest from '../../ajax';
import { ERROR, GET_INVITES } from "../actionTypes";

export const getInviteAction = (dispatch, page) =>
  httpRequest('get', `/invitees/${page}/10`)
    .then(({ data: { data } }) => {
      const invitees = data?.['0'] ?? data?.[0] ?? [];
      const totalCount = data?.total_count ?? 0;
      const action = {
        type: GET_INVITES,
        payload: { invitees, total_count: totalCount, page },
      };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const action = {
        payload: response?.data?.message || 'Failed to load invitees',
        type: ERROR,
      };
      dispatch(action);
      return action;
    });
